/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  getInboxViews(agentId) {
    return axios.get(`${this.url}/${agentId}/inbox_views`);
  }

  updateInboxViews(agentId, inboxViews) {
    return axios.patch(`${this.url}/${agentId}/inbox_views`, {
      inbox_views: inboxViews,
    });
  }

  getInboxes(agentId) {
    return axios.get(`${this.url}/${agentId}/inboxes`);
  }

  updateInboxes(agentId, inboxIds) {
    return axios.patch(`${this.url}/${agentId}/inboxes`, {
      inbox_ids: inboxIds,
    });
  }
}

export default new Agents();
